import * as React from 'react';

function SvgMyWallet(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="my_wallet_svg__clip-path">
          <path
            id="my_wallet_svg__Rectangle_295"
            d="M0 0h24v24H0z"
            data-name="Rectangle 295"
            transform="translate(116 754)"
            stroke="#707070"
            fill="#fff"
          />
        </clipPath>
        <style>{'.my_wallet_svg__cls-3{fill:#235dd4}'}</style>
      </defs>
      <g
        id="my_wallet_svg__my_wallet"
        transform="translate(-116 -754)"
        clipPath="url(#my_wallet_svg__clip-path)"
      >
        <g id="my_wallet_svg__Group_348" data-name="Group 348" transform="translate(193.803 756.5)">
          <path
            id="my_wallet_svg__Path_667"
            d="M18.989 0H.826A.826.826 0 000 .826v14.861a.826.826 0 00.826.826h1.651a.826.826 0 100-1.651h-.826V1.651h16.513v3.3h-4.129a3.3 3.3 0 000 6.6h4.128v3.3H5.779a.826.826 0 100 1.651h13.21a.826.826 0 00.826-.826V.826A.826.826 0 0018.989 0zm-4.954 9.907a1.651 1.651 0 010-3.3h4.128v3.3z"
            className="my_wallet_svg__cls-3"
            data-name="Path 667"
            transform="translate(-73.618)"
          />
          <path
            id="my_wallet_svg__Path_668"
            d="M273.651 144h-.826a.826.826 0 000 1.651h.826a.826.826 0 100-1.651z"
            className="my_wallet_svg__cls-3"
            data-name="Path 668"
            transform="translate(-331.582 -136.569)"
          />
          <g
            id="my_wallet_svg__Group_347"
            data-name="Group 347"
            transform="translate(-77.623 4.646)"
          >
            <path
              id="my_wallet_svg__Path_669"
              d="M-42.806 117.755a5.957 5.957 0 00-1.974-3.29 5.135 5.135 0 00-2.111-1.152 5.3 5.3 0 00-1.727-.274 5.945 5.945 0 00-6 5.895 5.945 5.945 0 005.895 6 6.083 6.083 0 004.085-1.563A5.889 5.889 0 00-43 120.744a5.461 5.461 0 00.274-1.755c.026-.439-.08-.85-.08-1.234z"
              data-name="Path 669"
              transform="translate(55.81 -111.852)"
              fill="#e92c81"
            />
            <path
              id="my_wallet_svg__Path_670"
              d="M-70.482 91.226h.051a5.3 5.3 0 011.731.274 5.135 5.135 0 012.111 1.152 5.956 5.956 0 011.974 3.29c0 .384.11.8.082 1.234a5.46 5.46 0 01-.274 1.755 5.889 5.889 0 01-1.645 2.632 6.083 6.083 0 01-4.085 1.563 5.945 5.945 0 01-5.895-6 5.944 5.944 0 015.954-5.9m0-1.187a7.1 7.1 0 00-5.03 2.061 7.082 7.082 0 00-2.114 5.009 7.1 7.1 0 002.043 5.067 7.08 7.08 0 005.029 2.134h.01a7.268 7.268 0 004.88-1.869l.006-.006.006-.006a7.082 7.082 0 001.97-3.145 6.621 6.621 0 00.329-2.077 5.158 5.158 0 00-.049-.9 3.6 3.6 0 01-.033-.371v-.127l-.027-.125a7.15 7.15 0 00-2.353-3.932 6.306 6.306 0 00-2.538-1.391 6.517 6.517 0 00-2.076-.327z"
              className="my_wallet_svg__cls-3"
              data-name="Path 670"
              transform="translate(77.623 -90.039)"
            />
          </g>
          <path
            id="my_wallet_svg__Path_671"
            d="M16.882 161.448h-.658c-.055-.274-.137-.548-.247-.548h.9a.548.548 0 000-1.1h-3.97a.548.548 0 100 1.1h1.152a1.187 1.187 0 01.987.548h-2.139a.548.548 0 100 1.1h2.139c-.027 0-.11.165-.192.247a.976.976 0 01-.8.3h-1.147a.569.569 0 00-.576.521.546.546 0 00.192.439l2.852 2.687a.541.541 0 00.384.165.576.576 0 00.384-.192.521.521 0 000-.74l-.027-.027-1.837-1.755a2.279 2.279 0 001.371-.631 2.868 2.868 0 00.576-1.014h.658a.548.548 0 000-1.1z"
            data-name="Path 671"
            transform="translate(-85.312 -151.557)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgMyWallet;
